// extracted by mini-css-extract-plugin
module.exports = {"header":"_6h1jp","title-label":"_3gcxw","titleLabel":"_3gcxw","close":"LFG0g","red":"_2MFfI","blue":"_2MXiJ","green":"_3mrl5","lightGreen":"GElN-"};